import React from 'react';
import Modal from '@components/common/modal';
import Button from '@components/common/button';

import classnames from 'classnames/bind';
import styles from './leaveModal.module.scss';
const cx = classnames.bind(styles);

interface Props {
  visible: boolean;
  onClose: () => void;
  onOk: () => void;
}

const LeaveModal = ({ visible, onClose, onOk }: Props) => {
  return (
    <Modal visible={visible}>
      <div className={cx('leaveModal')}>
        <h3 className={cx('leaveModalTitle')}>페이지에서 나가시겠어요?</h3>
        <p className={cx('leaveModalDesc')}>저장되지 않은 정보는 사라집니다.</p>
        <div className={cx('buttons')}>
          <Button className={cx('button')} onClick={onClose} theme="secondary">
            취소
          </Button>
          <Button className={cx('button')} onClick={onOk}>
            나가기
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default LeaveModal;
